import * as TaskActions from '../constants/taskConstants';

function mergeById(head, tail) {
    const seen = new Set();
    const out = [];
    for (const task of [...head, ...tail]) {
        if (!task?._id || seen.has(task._id)) continue;
        seen.add(task._id);
        out.push(task);
    }
    return out;
}

/** Same length and order; replace objects whose _id appears in `tasks`. */
function patchById(taskList, tasks) {
    if (!tasks?.length) return taskList;
    const incomingById = new Map();
    for (const task of tasks) {
        if (!task?._id) continue;
        incomingById.set(task._id, task);
    }
    if (!incomingById.size) return taskList;
    return taskList.map((task) => incomingById.get(task._id) || task);
}

const InitialState = {
    taskList: [],
    startCursor: null,
    endCursor: null,
    hasMoreOlder: false,
    lastClickedElement: {
		id: null,
	},
};

const task = (state = InitialState, action) => {
    switch(action.type) {

        case TaskActions.SET_TASKS: {
            const { mode, tasks, startCursor, endCursor, hasMoreOlder } = action.data;
            if (mode === "append") {
                return {
                    ...state,
                    taskList: mergeById(state.taskList, tasks),
                    endCursor,
                    hasMoreOlder,
                };
            }
            if (mode === "prepend") {
                return {
                    ...state,
                    taskList: mergeById(tasks, state.taskList),
                    startCursor,
                };
            }
            if (mode === "patch") {
                return {
                    ...state,
                    taskList: patchById(state.taskList, tasks),
                };
            }
            return {
                ...state,
                taskList: tasks,
                startCursor,
                endCursor,
                hasMoreOlder,
            };
        }

        case TaskActions.SET_LAST_CLICKED_ELEMENT:
            return {
                ...state,
                lastClickedElement: action.data,
            };

        case TaskActions.CLEAR_STATE:
            return {
                ...InitialState,
            };

        default : 
            return {
                ...state
            };
    }
}

export default task;
